import { useQuery } from "@tanstack/react-query";
import useWidgetStore from "../../store/useWidgetStore";
import ConfigHolder from "../../config/ConfigHolder";
import { prepareUrl } from "../../context/WidgetContext";
import { useSettings } from "../../context/SettingsContext";
import dayjs from 'dayjs';
export const useTimes = (options) => {
    const { enabled, selectedApptype, selectedResource, selectedDate, selectedGroup, selectedCapacity, selectedCapacityGroups } = useWidgetStore();
    const { api_key, widget_id, displayRemainingCapacity, displayNoCapacity } = useSettings();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: enabled.date && selectedCapacity > 0, networkMode: "online", cacheTime: 60 * 1000 * 2, staleTime: 60 * 1000 * 2 });
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-time', selectedApptype, selectedResource, selectedDate, selectedCapacity, selectedCapacityGroups], queryFn: async ({ signal }) => {
            let url = new URL(`/consumer/booking/api/method/getBookables`, 
            // `/consumer/booking/api/method/getTimes`,
            ConfigHolder.apiBaseUrl);
            let month = selectedDate && selectedDate[0] !== undefined
                ? dayjs(selectedDate[0]).format('YYYYMM')
                : dayjs().format('YYYYMM');
            let capacities = JSON.stringify(selectedCapacityGroups);
            if (selectedCapacityGroups[0]) {
                // if group 0 is "set", make sure it represent the overall capacity
                capacities = JSON.stringify({ 0: selectedCapacity });
            }
            let params = {
                filter_apptype: '',
                filter_resource: '',
                apptypes: selectedApptype === null || selectedApptype === void 0 ? void 0 : selectedApptype.join(','),
                resource: selectedResource && selectedResource[0] !== undefined ? selectedResource.join(',') : -1,
                category: selectedGroup && selectedGroup[0] !== undefined ? selectedGroup.join(',') : -1,
                capacity: selectedCapacity,
                capacities: capacities,
                month: month
            };
            if (displayNoCapacity || displayRemainingCapacity) {
                params.include = "capacity";
            }
            url = prepareUrl(url, 'getBookables', api_key, widget_id, params);
            const response = await fetch(url.href, {
                signal: signal,
                headers: {
                    'accept': 'application/ld+json',
                }
            });
            return response.json();
        } }));
};
